export default __webpack_public_path__ + "static/media/linkedin-blue.f8a5f230.svg";